module.exports = __webpack_public_path__ + "static/media/meiaCalca.8041ce64.png";